import { render, staticRenderFns } from "./FileUploadComponent.vue?vue&type=template&id=b4d2fc00"
import script from "./FileUploadComponent.vue?vue&type=script&lang=js"
export * from "./FileUploadComponent.vue?vue&type=script&lang=js"
import style0 from "./FileUploadComponent.vue?vue&type=style&index=0&id=b4d2fc00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports